import AccountInfoPopover from "./AccountInfoPopover/index.vue";
import UpdatePasswordDialog from "./UpdatePasswordDialog/index.vue";
import UpdateKeyCodeDialog from "./UpdateKeyCodeDialog/index.vue";
import Auth from "../../../utils/auth";
import { WebsiteUrl } from "../../../utils";

export default {
	name: 'ModuleBox',
	components: {
		AccountInfoPopover,
		UpdatePasswordDialog,
		UpdateKeyCodeDialog
	},
	data(){
		return{
			ValueData:'111',
			AdminPasswordDialogVisible:false,
			AdminKeyCodeDialogVisible:false,

			Info:JSON.parse(Auth.getInfo()),
			AdminName:'',

			ModuleHeaderLogoUrl:WebsiteUrl()+'/images/ModuleHeaderLogo.png',
		}
	},
	methods:{

	},
	mounted(){
		this.AdminName = this.Info.AdminName;
	},
    watch: {

    },
    emits:{

    }
}